import React, { useEffect, useRef } from 'react';

// UDRAW-S1 §3 — sticky-bottom "HIERARCHY" tree (renamed from
// "МЯСТО В ЗАДАЧАТА" by PO after the S1 review — English label to
// match the rest of the drawer chrome).
// The tree is data-driven: DeliveryPage already owns the full hierarchy
// (tasks, hasChildTasksById, workItemsByTask, kids), so it builds a
// pre-flattened `treeData` array and hands it in:
//   [{ key, kind: 'phase'|'task'|'wi', badge?: 'M'|'A'|'C'|'N',
//      label: string, hours?: number|null, indent: number,
//      isCurrent: boolean }, …]
// Clicks route back through `onNavigate(node)` — DeliveryPage
// dispatches to its normal row-click flow (WI drawer / info drawer /
// quickLog drawer). This component computes nothing itself.

const badgeColor = (b) => {
  switch (b) {
    case 'A': return '#2f6fed';
    case 'C': return '#2fa84f';
    case 'M': return '#e08a2f';
    case 'N':
    default:  return '#8a8a8a';
  }
};

export default function DrawerTaskTree({ treeData, onNavigate }) {
  const scrollerRef = useRef(null);

  useEffect(() => {
    // Auto-scroll the current row into view when it moves.
    if (!scrollerRef.current) return;
    const cur = scrollerRef.current.querySelector('[data-current="true"]');
    if (cur && typeof cur.scrollIntoView === 'function') {
      cur.scrollIntoView({ block: 'nearest' });
    }
  }, [treeData]);

  if (!Array.isArray(treeData) || treeData.length === 0) return null;

  return (
    <div className="udraw-tree" data-testid="wi-drawer-tree">
      <div className="udraw-tree-hd">HIERARCHY</div>
      <div className="udraw-tree-bd" ref={scrollerRef}>
        {treeData.map((n) => (
          <div
            key={n.key}
            data-testid={`wi-drawer-tree-node-${n.key}`}
            data-current={n.isCurrent ? 'true' : undefined}
            className={`udraw-tree-node${n.isCurrent ? ' cur' : ''}`}
            style={{ paddingLeft: 8 + (n.indent || 0) * 18 }}
            onClick={() => !n.isCurrent && onNavigate && onNavigate(n)}
          >
            {n.badge ? (
              <span className="udraw-tree-badge" style={{ background: badgeColor(n.badge) }}>{n.badge}</span>
            ) : (
              <span className="udraw-tree-badge" style={{ background: '#c9cfda' }}>▦</span>
            )}
            <span className="udraw-tree-label">{n.label}</span>
            {n.hours != null && Number(n.hours) > 0 && (
              <span className="udraw-tree-hours">{Number(n.hours).toFixed(1)} h</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
